<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card flat class="text-xs-center ma-3" width="100%">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Documentos Atlas</span>
                    </v-card-title>
                    <v-card-text>
                        <br />
                        <DataTable v-if="ver" :url="url"
                                   :columns="head"
                                   :params="displayInputs"
                                   :order="[[0, 'desc']]"
                                   :formatterActions="formatterActions"
                                   select="multiple"
                                   @input="seleccionarReportes"
                                   :dom="'Bfrtip'"
                                    :todo="false"
                                   @SeleccionTabla="SeleccionarTodo"
                                   class="tablaEspecial"
                                   @apiDT="apiDT = $event">
                        </DataTable>

                        <br />
                        <v-row justify="center">
                            <v-btn class="ma-2"
                                   :disabled="loadingB"
                                   @click="Guardar()"
                                   color="success">
                                Enviar Seguimiento
                                <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
                <div v-show="showLightbox">
                    <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                              @onClosed="CerrarVisor()" />
                </div>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import General from "@/services/Operacion/Operacion.service.js";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import LightBox from '@/components/pages/Visor/LightBox.vue';
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
            LightBox
        },
        data() {
            return {
                valid: true,
                showcargando: true,
                apiDT: null,
                displayInputs: {},
                url: "Operacion/ArchivoAtlas",
                head: [
                    { name: "Reporte", data: "Reporte", title: "Reporte", formatter: [this, "detalleReporte"], },
                    { name: "dodescrip", data: "dodescrip", title: "Documento" },
                    { name: "docalta", data: "docalta", title: "Fecha" },
                    { name: "docid", data: "docid", title: "", formatter: [this, "formatearVer"], orderable: false },
                ],
                formatterActions: [
                    { click: [this, "VerArchivo"] },
                    { click: [this, "BuscarReporte"] },
                ],
                ver: false,
                loadingB: true,
                seleccion: [],

                sPDF: false,
                media: [{
                    src: '@/',
                    type: ''
                }],
                showLightbox: false,
                overlay: false,
            }
        },
        watch: {
            seleccion() {
                if (this.seleccion.length > 0)
                    this.loadingB = false;
                else
                    this.loadingB = true;
            }
        },
        methods: {
            SeleccionarTodo(tipo) {
                if (tipo == 1) {
                    const rows = this.apiDT.rows({ page: 'current' });
                    rows.select();
                    if (this.permisoCausion == false) {
                        this.apiDT.rows('.blocked-row').deselect();
                    }
                } else if (tipo == 2) {
                    const rows = this.apiDT.rows({ page: 'current' });
                    rows.deselect();
                } else if (tipo == 3) {
                    const rows = this.apiDT.rows({ page: 'current' });
                    rows.every(function () {
                        if (this.nodes().to$().hasClass('selected')) {
                            this.deselect();
                        } else {
                            this.select();
                        }
                    });
                    this.apiDT.rows('.blocked-row').deselect();
                }
            },
            async Guardar() {
                let formdata = new FormData();
                formdata.append("archivos", JSON.stringify(this.seleccion));
                this.$swal({
                    position: "center",
                    title: "Procesando la Solicitud ...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                let width = '60em';
                this.$swal.showLoading();
                await UtilidadesServ.ArchivosAtlasEnvio(formdata).then(data => {
                    if (data.length == 0) {
                        this.$swal({
                            position: "center",
                            title: "Atención",
                            text: "Se guardó la información correctamente",
                            icon: "success",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                    }
                    else if (data == false) {
                        this.$swal({
                            position: "center",
                            title: "Atención",
                            text: "Ocurrió un error al procesar los datos",
                            icon: "error",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                    }
                    else {
                        let inf = "info";
                        let tabla = "<div style='text-align: center;'><table style='margin: 0 auto;'>";
                        
                        for (var i = 0; i < data.length; i++) {
                            tabla += "<tr>";
                            tabla += "<td style='padding: 8px 8; width: 130px;'>" + data[i].nrreporte + "-" + data[i].svindice + "</td>";
                            tabla += "<td style='padding: 8px 8px; text-align: justify'>" + data[i].error + "</td>";
                            if (data[i].documento != null)
                                tabla += "<td style='padding:  8px 8px;'>" + data[i].documento + "</td>";
                            else
                                tabla += "<td style='padding:  8px 8px;'>Expedientes</td>";
                            tabla += "</tr>";
                        }
                        tabla += "</table></div>"
                        this.$swal({
                            position: "center",
                            title: "Atención",
                            html: tabla,
                            icon: inf,
                            width: '60em',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                    }
                    this.loadingB = true;
                    this.seleccion = [];
                    this.reloadTable();
                });
                
            },
            detalleReporte(datos) {
                if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                    return `<div class="ml-3"><button data-action="1" data-params="${datos.nrreporte}" class="dt-formatterAction ma-1 reporteindice">${datos.nrreporte}-${datos.svindice}</span></button></div>`;
                } else {
                    return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
                }
            },
            async BuscarReporte(params, item, fila) {
                let reporte = {
                    nrreporte: item.nrreporte,
                    svindice: item.svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };
                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", item.nrreporte);
                formData.append("svindice", item.svindice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });
                let url = '';

                if (ver == 0) {
                    url = this.$router.resolve({ name: `${"DatosIncompletos"}` });
                }
                else {
                    let routerName = MetodosGenerales.obtenerRouterName(item.aiclave.toString());
                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    url = this.$router.resolve({ name: `${routerName}` });
                }
                window.open(url.href, '_blank');
            },
            async VerArchivo(params, datos) {
                let reporte = {
                    nrreporte: datos.nrreporte,
                    svindice: datos.svindice,
                };
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

                this.showLightbox = false;
                this.overlay = true;
                this.media = this.media.filter(obj => obj.src == '@/');
                this.isPDF = /\.pdf$/i.test(datos.docarchivo);
                let dir = await Archivos.ObtenerDireccion(datos, datos.docid, 1);

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Documentos');
                formData.append("laaccion", "Vio Documento");
                formData.append("lacaracteristicas", datos.nrreporte + '-' + datos.svindice);
                formData.append("lanombre", dir.archivo);
                formData.append("ladestinatario", "");

                await Archivos.AlmacenarVisitas(formData);
                if (dir.archivo !== null) {
                    var img = {
                        src: dir.watch,
                        caption: '<h4>' + datos.dodescrip + '</h4>',
                        type: this.isPDF == true ? 'pdf' : 'img',
                        width: '800px',
                        docid: datos.docid,
                        paginas: datos.docpaginas
                    };
                    this.media.push(img);
                    this.media = this.media.filter(obj => obj.src !== '@/');
                    this.showLightbox = true;
                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Error',
                        text: dir.msg,
                        showConfirmButton: false,
                        timer: 2500
                    });
                    this.verarchi = false;
                }
                this.overlay = false;
            },
            async CerrarVisor() {
                var img = {
                    src: '@/',
                    type: 'img'
                }
                this.media = [];
                this.media.push(img);
                this.showLightbox = false;
                await this.$refs.lightbox.showImage(0);
            },
            formatearVer(data) {
                return data.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${data.docid}" title="Ver Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-eye theme--dark"></i></span></button></div>` : ``;
            },
            seleccionarReportes(reporte) {
                this.seleccion = reporte;
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
        },
        async mounted() {
            this.showcargando = false;
            this.displayInputs = {
                clclave: this.clclave,
            };
            this.ver = true;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '368').then(response => {

                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
    }
</script>
<style scoped>
    .swal2-popup {
        width: 1000px !important; /* Establece el ancho deseado */
    }
</style>
<style>
    .tablaEspecial div.dt-buttons {
        float: right;
    }

    .tablaEspecial div.dataTables_wrapper div.dataTables_filter {
        text-align: left;
    }

    .tablaEspecial .dataTables_wrapper .dataTables_filter {
        float: left;
        text-align: left;
    }
</style>